// FormRateCardAutoComplete Component

import React from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import classnames from 'classnames'

import Input from '../input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import FormAutoComplete from '../auto_complete/auto_complete.jsx'
import InputTax from '../input_tax/input_tax.jsx'

class FormVatAutoComplete extends FormAutoComplete {
  static get propTypes () {
    return {
      showVatAdd: PropTypes.bool,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      displayValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }
  }

  static get defaultProps () {
    return {
      showVatAdd: false,
      value: '',
      displayValue: ''
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      showVatAddMsg: false,
      showVatAdd: !!props.showVatAdd
    }

    this._references = {}
    this._createBaseReferences(this._references)
  }

  render () {
    return (
      <div
        className='form-autocomplete vatautocomplete'
        ref={this._references.select}
      >
        <div className='form-autocomplete-field'>{this._renderField()}</div>

        {this._renderOptions()}
      </div>
    )
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    this.setState({ value: nextProps.displayValue })

    if (nextProps.showAdd !== this.state.showAdd) {
      this.setState({ showAdd: nextProps.showAdd })
    }

    if (nextProps.showVatAdd !== this.state.showVatAdd) {
      this.setState({ showVatAdd: nextProps.showVatAdd })
    }
  }

  _renderObjectItems () {
    this.props.options.map(option => {
      option.labelHasHtml = option.labelHasHtml ? option.labelHasHtml : false
    })
    return this.props.options.map((opt, idx) => (
      <div
        className={`option-item ${opt.editable ? ' vatinput' : ''}`}
        key={idx}
        onClick={!opt.editable ? this._handleSelect.bind(this, opt) : null}
      >
        {this._renderOptionLabel(opt)}
      </div>
    ))
  }

  _renderField () {
    const _className = classnames(
      'form-group',
      {
        has_error: this.state.error
      },
      this.props.className
    )

    return (
      <div className={_className}>
        <InputTax
          ref={this._references.refInput}
          type='text'
          name={this.props.name}
          label={this.props.label}
          value={this.props.displayValue}
          size={10}
          maxLength={100}
          prefixIcon='form-search'
          onChange={this._onChange.bind(this)}
          onBlur={this._handleBlur.bind(this)}
          onKeyDown={this.props.onKeyDown}
          onFocus={
            this.props.selectValue
              ? this._handleSelectFocus.bind(this)
              : this._handleFocus.bind(this)
          }
        />
        {this.props.showOptionIcon && this.props.options.length > 0 && (
          <IconButton
            icon='phase-ratecard-available'
            size='normal'
            canHover={false}
            className='phase-ratecard'
            onClick={this._onClickOptionIcon.bind(this)}
          />
        )}
      </div>
    )
  }

  _renderOptions () {
    if (this.state.showAdd || !this.state.showSelection) {
      return ''
    }

    const keywordLen = this.props.displayValue
      ? this.props.displayValue.length
      : 0
    if (
      !this.state.showVatAdd &&
      this.state.showSelection &&
      this.props.options.length > 0 &&
      keywordLen >= this.props.keywordLength
    ) {
      return (
        <div className='autocomplete-options' ref={this._references.selectDrop}>
          {this._renderObjectItems()}
        </div>
      )
    } else if (
      !this.state.showVatAdd &&
      (keywordLen < this.props.keywordLength ||
        (this.props.options.length < 1 &&
          this.props.displayValue === this.props.value))
    ) {
      return ''
    }

    let showButton = ''
    if (this.props.bShowButton) {
      showButton = (
        <IconButton
          type='primary'
          size='big'
          icon='autocomplete-add'
          title='common.list.titleAdd'
          canHover={false}
          className='wizard-client-add vataddbtn'
          onClick={this._handleAddClick.bind(this)}
        />
      )
    }

    const _class = classnames(
      'autocomplete-message',
      {},
      `autocomplete-message_${this.props.className}`
    )

    const errorMsg = IntlUtil.convertMessage('common.list.autocompleteVatError')
    let msgTitle = `${errorMsg}`
    if (this.props.errorLabel) {
      msgTitle = <IntlMessage ident={this.props.errorLabel} />
    }

    let msgText = (
      <p>
        <IntlMessage ident='common.list.autoCompleteCreateVatTitle' />
        <IntlMessage ident='common.list.autoCompleteVatClick' />
        <i className='icon icon-autocomplete-plus' />
        <IntlMessage ident='common.list.autoCompleteVatButton' />
      </p>
    )

    if (this.props.errorMessage) {
      msgText = (
        <p>
          <IntlMessage ident={this.props.errorMessage} />
          <i className='icon icon-autocomplete-plus' />
          <IntlMessage ident='common.list.autoCompleteVatButton' />
        </p>
      )
    }

    if (!this.props.hideAdd) {
      return (
        <div className={_class} ref={this._references.selectDrop}>
          {showButton}
          <h2>{msgTitle}</h2>
          {msgText}
        </div>
      )
    } else {
      return ''
    }
  }

  _renderOptionLabel (opt) {
    if (!opt.labelHasHtml) {
      return (
        <div className='cont'>
          {opt.editable ? (
            <Input
              type='text'
              name='vatValue'
              label='common.list.addVatDescription'
              value={opt.label}
              size={10}
              maxLength={100}
              autoFocus
              className='project-clientadd'
              styleDotted={false}
              onChange={this._onVatDescChange.bind(this, opt)}
              onBlur={this._handleVatDescBlur.bind(this, opt)}
              onKeyDown={this._handleVatDescKeydown.bind(this, opt)}
            />
          ) : (
            <span className='vattitle'>{opt.label}</span>
          )}
          <span className='perc'>{opt.value}%</span>
        </div>
      )
    }

    return <div dangerouslySetInnerHTML={{ __html: opt.label }} />
  }

  _onVatDescChange (opt, value) {
    opt.label = value
    this.setState({ dataDate: new Date() })
  }

  _renderVatAddInput () {
    return (
      <div className='vatadd'>
        <span className='val'>{this.props.addValue}</span>
      </div>
    )
  }

  _handleVatDescKeydown (opt, ev) {
    if (ev.keyCode === 13 && opt.label && this.props.onSaveVat) {
      opt.editable = false
      this.props.onSaveVat(opt)
      this.hideAdd()
      this.setState({ dataDate: new Date() })
    }
  }

  _handleVatDescBlur (opt) {
    if (opt.label && this.props.onSaveVat) {
      opt.editable = false
      this.props.onSaveVat(opt)
      this.hideAdd()
      this.setState({ dataDate: new Date() })
    }
  }

  _handleAddClick (e) {
    e.preventDefault()
    this.props.options.push({
      label: '',
      value: this.props.displayValue,
      editable: true
    })
    this.setState({ showVatAdd: false, dataDate: new Date() })
  }

  _handleDocumentClick = evt => {
    if (
      (this.state.showSelection || this.state.showAdd) &&
      this._references.select.current &&
      this._references.selectDrop.current
    ) {
      const area = ReactDom.findDOMNode(this._references.select.current)
      const dropArea = ReactDom.findDOMNode(this._references.selectDrop.current)

      if (!area.contains(evt.target) && !dropArea.contains(evt.target)) {
        if (this.state.showSelection) {
          this.setState({ showSelection: false })
        } else {
          this.setState({ showAdd: false })
        }

        if (this.props.onBlur) {
          this.props.onBlur(evt)
        }
      }
    }
  }
}

export default FormVatAutoComplete
